import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  elementColours,
  fontSize,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Button, HtmlContent } from './ui';

const StyledServiceCta = styled.article`
  position: relative;
  padding: 30px;
  background-color: ${standardColours.white};
  border-radius: 40px;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px;
  `}
`;

const StyledHeading = styled.h3`
  color: ${brandColours.secondary};
  ${fontSize(21)};

  ${minBreakpointQuery.small`
    ${fontSize(23)};
  `}

  ${minBreakpointQuery.small`
    ${fontSize(25)};
  `}
`;

const StyledIconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
  height: 70px;
  width: 70px;
  background-color: ${({ backgroundColour }) => backgroundColour.hex};
  border-radius: 50%;
  transform: translate(25%, -25%);

  ${minBreakpointQuery.small`
    padding: 20px;
    height: 85px;
    width: 85px;
  `}

  ${minBreakpointQuery.large`
    padding: 25px;
    height: 100px;
    width: 100px;
  `}
`;

const StyledIcon = styled.img`
  height: 100%;
  width: 100%;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 16px;
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
  color: ${elementColours.textColour};
  background-color: ${standardColours.white};
  border: 2px solid ${brandColours.secondary};
`;

const ServiceCta = ({ heading, icon, colour, text, page, ...props }) => (
  <StyledServiceCta {...props}>
    <StyledHeading>{heading}</StyledHeading>
    <StyledIconWrapper backgroundColour={colour}>
      <StyledIcon src={icon.url} alt={icon.alt} loading="lazy" />
    </StyledIconWrapper>
    <StyledText content={text} />
    <StyledButton to={page}>Learn More</StyledButton>
  </StyledServiceCta>
);

export default ServiceCta;
